import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { isTreatment, safeBoolean } from '../../utils/utils'
import * as badgeSt from './badge.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'

export interface IXRayBadgeProps extends AtfTreatmentProps {
  isXRay?: boolean
}

export const XRay = ({ isXRay, atfTreatment }: IXRayBadgeProps) => (
  safeBoolean(isXRay) && (
    <Badge use={badges.BORDERED_TEXT}>
      <span {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} data-automation-id="x-ray-badge">X-Ray</span>
    </Badge>) || null
)
